import React from 'react';

import styled from '@emotion/styled';

import CustomToggleModeSelectField from '../../../components/FormCom/CustomToggleModeSelectField';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import useToggleDashboardMode from '../../../hooks/dashboard/dashboardLoading/useToggleDashboardMode';
import {
  ToggleDashboardModeInitialValues,
  ToggleDashboardModeSchema,
} from '../../../models/dashboard/dashboard/togglesDashboardModeData';
import { useAppSelector } from '../../../redux/store';

const fieldRecord: Record<string, boolean> = {
  'Live Mode': false,
  'Dev Mode': true,
};

const ToggleMode = () => {
  const { businessInfo } = useAppSelector((state) => state.businessInfoData);
  const { getToggleDashboardMode, loading } = useToggleDashboardMode();

  const handleFieldChange = (mode: string) => {
    if (
      fieldRecord[mode] !== undefined &&
      businessInfo?.isTestMode !== fieldRecord[mode]
    ) {
      getToggleDashboardMode({
        isTestMode: fieldRecord[mode] ?? false,
      });
    }
  };

  if (!businessInfo?.isTestMode) {
    ToggleDashboardModeInitialValues.mode = 'Live Mode';
  } else {
    ToggleDashboardModeInitialValues.mode = 'Dev Mode';
  }

  return (
    <Container>
      <FormComponent
        initialValues={ToggleDashboardModeInitialValues}
        schema={ToggleDashboardModeSchema}
        onSubmit={() => {}}
      >
        <CustomToggleModeSelectField
          name='mode'
          id='mode'
          placeholder='Select Mode'
          onChange={handleFieldChange}
          optionData={Object.keys(fieldRecord).map((key) => key)}
          loading={loading}
        />
      </FormComponent>
    </Container>
  );
};

export default ToggleMode;

const Container = styled.div`
  display: flex;
  width: 125px;
  margin-right: 20px;
`;
